Wee.fn.make('quoteForm', {
	init: function() {
		var $priv = this.$private,
			stateDropdown = new Wee.fn.dropdown(),
			preferredRepresentativeDropdown = new Wee.fn.dropdown(),
			$preferredRepresentativeValue = $('.freeform-column.-preferredRepresentativeValue');

		stateDropdown.init({
			selector: 'ref:stateDropdown',
			prefix: 'stateDropdown',
			placeholder: 'Select A State'
		});

		$preferredRepresentativeValue.hide();
		preferredRepresentativeDropdown.init({
			selector: 'ref:preferredRepresentativeDropdown',
			prefix: 'preferredRepresentativeDropdown',
			isSelected: true,
			itemClick: function(option) {
				if (option.value == 'Yes') {
					$preferredRepresentativeValue.show();
					$preferredRepresentativeValue.find('input')[0].focus();
				} else {
					$preferredRepresentativeValue.hide();
				}
			}
		});

		// Wee.dropdown.init({
		// 	placeholder: 'Select A State'
		// });

		$priv.addData();
		$priv.initEvents();
	},

	unload: function() {
		$.events.off(false, '.quoteForm');
	}
}, {
	/**
	 * Add data from session storage to quote form
	 *
	 * @private
	 */
	addData: function() {
		this.store = Wee.fn.storage();

		var data = this.store.get('items'),
			prettyData = [];

		for (var i = 0; i < data.length; i++) {
			for (var key in data[i]) {
				switch (key) {
					case 'productTitle':
						prettyData.push('Product Name: ' + data[i].productTitle);
						break;
					case 'productPrice':
						prettyData.push('Price: ' + data[i].productPrice);
						break;
					case 'productImage':
						prettyData.push('Image: ' + data[i].productImage);
						break;
					case 'productParentPartNumber':
						prettyData.push('Parent Part Number: ' + data[i].productParentPartNumber);
						break;
					case 'productUniquePartNumber':
						prettyData.push('Unique Part Number: ' + data[i].productUniquePartNumber);
						break;
					case 'productLength':
						prettyData.push('Length: ' + data[i].productLength);
						break;
					case 'customLength':
						prettyData.push('Custom Length: ' + data[i].customLength);
						break;
					case 'productWidth':
						prettyData.push('Width: ' + data[i].productWidth);
						break;
					case 'customWidth':
						prettyData.push('Custom Width: ' + data[i].customWidth);
						break;
					case 'productSize':
						prettyData.push('Size: ' + data[i].productSize);
						break;
					case 'productMount':
						prettyData.push('Mount: ' + data[i].productMount);
						break;
					case 'productFinish':
						prettyData.push('Finish: ' + data[i].productFinish);
						break;
					case 'productExtrasCategory':
						prettyData.push('Extras: ' + data[i].productExtrasCategory);
						break;
					case 'productAdaAccessibility':
						prettyData.push('ADA Accessibility: ' + data[i].productAdaAccessibility);
						break;
					case 'productBackrest':
						prettyData.push('Backrest: ' + data[i].productBackrest);
						break;
					case 'productArmrest':
						prettyData.push('Armrest: ' + data[i].productArmrest);
						break;
					case 'productShape':
						prettyData.push('Shape: ' + data[i].productShape);
						break;
					case 'productPitch':
						prettyData.push('Pitch: ' + data[i].productPitch);
						break;
					case 'productEaveHeight':
						prettyData.push('Eave Height: ' + data[i].productEaveHeight);
						break;
					case 'productCapacity':
						prettyData.push('Capacity: ' + data[i].productCapacity);
						break;
					case 'productRoofPanel':
						prettyData.push('Roof Panel: ' + data[i].productRoofPanel);
						break;
					case 'productLattice':
						prettyData.push('Lattice: ' + data[i].productLattice);
						break;
					case 'productHandrail':
						prettyData.push('Handrail: ' + data[i].productHandrail);
						break;
					case 'productLid':
						prettyData.push('Lid Option: ' + data[i].productLid);
						break;
					case 'productColorOption':
						prettyData.push('Color: ' + data[i].productColorOption);
						break;
					case 'productSeatColor':
						prettyData.push('Seat Color: ' + data[i].productSeatColor);
						break;
					case 'productFrameColorOption':
						prettyData.push('Frame Color: ' + data[i].productFrameColorOption);
						break;
					case 'roofColorOption':
						prettyData.push('Roof Color: ' + data[i].roofColorOption);
						break;
					case 'columnColorOption':
						prettyData.push('Column Color: ' + data[i].columnColorOption);
						break;
					case 'muvColorOption':
						prettyData.push('MUV Color: ' + data[i].muvColorOption);
						break;
					case 'closedColorOption':
						prettyData.push('758 Closed Color: ' + data[i].closedColorOption);
						break;
					case 'openColorOption':
						prettyData.push('758 Open Color: ' + data[i].openColorOption);
						break;
					case 'gcColorOption':
						prettyData.push('7GC Color: ' + data[i].gcColorOption);
						break;
					case 'productFabricColor':
						prettyData.push('Fabric Color: ' + data[i].productFabricColor);
						break;
					case 'productLidColor':
						prettyData.push('Lid Color: ' + data[i].productLidColor);
						break;
					case 'productFrameColorPremium':
						prettyData.push('Frame Color Premium: ' + data[i].productFrameColorPremium);
						break;
					case 'productPattern':
						prettyData.push('Pattern: ' + data[i].productPattern);
						break;
					case 'lettering':
						prettyData.push('Lettering: ' + data[i].lettering);
						break;
					case 'icon':
						prettyData.push('Icon: ' + data[i].icon);
						break;
					case 'recycledPlankColor':
						prettyData.push('Recycled Plank Color: ' + data[i].recycledPlankColor);
						break;
					case 'woodPlankColor':
						prettyData.push('Wood Plank Color: ' + data[i].woodPlankColor);
						break;
					case 'quantity':
						prettyData.push('Quantity: ' + data[i].quantity + '\n');
						break;
				}
			}
		}

		$('#form-input-quoteCartData').val(prettyData.join('\n'));
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var $quoteForm = $('ref:quoteForm');

		$quoteForm.on('submit.quoteForm', function(e, el) {
			$('.quote-submit').attr('disabled', true);

			Wee.fetch.request({
				url: $('input[name=action]', el).val(),
				method: 'post',
				type: 'form',
				json: true,
				data: $quoteForm.serialize(),
				success: function(data) {
					if (data.returnUrl) {
						$.history.go({
							path: data.returnUrl
						});

						sessionStorage.clear();
					}
				}
			});

			e.preventDefault();
		});
	}
});